export const validateIdentityDocument = (nifToValidate: string): boolean => {
  const DNI_REGEX = /^(\d{8})([A-Z])$/;
  const NIE_REGEX = /^[XYZ]\d{7}[A-Z]$/;

  let document = nifToValidate.toUpperCase().replace(/\s/g, '');
  let isValid = false;

  if (DNI_REGEX.test(document)) {
    isValid = validateDni(document);
  } else if (NIE_REGEX.test(document)) {
    isValid = validateNie(document);
  } 

  return isValid;
};

const validateDni = (dni: string): boolean => {
  const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const numbers = parseInt(dni.slice(0, 8), 10);
  const letter = dni.charAt(8);

  return dniLetters[numbers % 23] === letter;
};

const validateNie = (nie: string): boolean => {
  const prefix = nie.charAt(0);
  let numericNie = nie;

  switch (prefix) {
    case 'X':
      numericNie = `0${nie.slice(1)}`;
      break;
    case 'Y':
      numericNie = `1${nie.slice(1)}`;
      break;
    case 'Z':
      numericNie = `2${nie.slice(1)}`;
      break;
    default:
      return false;
  }

  return validateDni(numericNie);
};




